/* TV - Tartan Request (sections/tv-tartan-request.liquid)
 * Images go straight from the browser to Cloudinary through an unsigned upload preset;
 * only their URLs are posted with the Shopify contact form. */
(function () {
  if (window.__tvxTreq) {
    window.__tvxTreq.initAll();
    return;
  }

  var MAX_RAW_BYTES = 15 * 1024 * 1024;
  var RESIZE_OVER_BYTES = 1.5 * 1024 * 1024;
  var MAX_DIMENSION = 2000;
  var IMAGE_TYPES = ['image/jpeg', 'image/png', 'image/webp'];
  var DRAFT_TTL_MS = 24 * 60 * 60 * 1000;
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  var CLOSE_SVG =
    '<svg viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M2 2l8 8M10 2l-8 8"/></svg>';

  function qs(el, sel) {
    return el.querySelector(sel);
  }

  function qsa(el, sel) {
    return Array.prototype.slice.call(el.querySelectorAll(sel));
  }

  function readConfig(root) {
    var node = qs(root, '[data-tvx-treq-config]');
    var cfg = {};
    try {
      cfg = JSON.parse(node.textContent);
    } catch (err) {}
    cfg.messages = cfg.messages || {};
    cfg.maxFiles = parseInt(cfg.maxFiles, 10) || 5;
    return cfg;
  }

  /* ---------- Desktop: keep the shorter column in view ----------
   * CSS position: sticky can't be used here: the theme sets overflow on both html and body,
   * which makes body the (never-scrolling) sticky container. The shorter column is moved
   * with a transform instead: short columns stick to the top, columns taller than the
   * viewport scroll until their bottom is visible and then stick to the bottom. */

  var STICKY_GAP = 24;

  function fixedHeaderHeight() {
    var offset = 0;
    qsa(document, '.shopify-section-group-header-group, header').forEach(function (el) {
      var cs = getComputedStyle(el);
      if (cs.position !== 'sticky' && cs.position !== 'fixed') return;
      var top = parseFloat(cs.top);
      if (isNaN(top) || top > window.innerHeight / 3 || !el.offsetHeight) return;
      offset = Math.max(offset, top + el.offsetHeight);
    });
    return offset;
  }

  function initSticky(root) {
    var grid = qs(root, '.tvx-treq__grid');
    if (!grid) return;
    var cols = [qs(grid, '.tvx-treq__main'), qs(grid, '.tvx-treq__side')].filter(Boolean);
    if (cols.length < 2 || !window.matchMedia) return;
    var desktop = window.matchMedia('(min-width: 990px)');
    var headerH = 0;
    var ticking = false;

    function update() {
      ticking = false;
      if (!desktop.matches) {
        cols.forEach(function (col) { col.style.transform = ''; });
        return;
      }
      var gridTop = grid.getBoundingClientRect().top;
      var gridH = grid.offsetHeight;
      var vh = window.innerHeight;
      var top = headerH + STICKY_GAP;
      var offsets = cols.map(function (col) {
        var colH = col.offsetHeight;
        var room = gridH - colH;
        if (room < 2) return 0;
        var y = colH + top + STICKY_GAP <= vh ? top - gridTop : vh - STICKY_GAP - colH - gridTop;
        return Math.round(Math.max(0, Math.min(room, y)));
      });
      cols.forEach(function (col, i) {
        col.style.transform = offsets[i] ? 'translate3d(0, ' + offsets[i] + 'px, 0)' : '';
      });
    }

    function schedule() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }

    function remeasure() {
      headerH = fixedHeaderHeight();
      schedule();
    }

    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', remeasure);
    if (desktop.addEventListener) desktop.addEventListener('change', remeasure);
    if (window.ResizeObserver) {
      var ro = new ResizeObserver(schedule);
      ro.observe(grid);
      cols.forEach(function (col) { ro.observe(col); });
    }
    window.addEventListener('load', remeasure);
    remeasure();
  }

  /* ---------- Sidebar product slider ---------- */

  function initSliders(root) {
    qsa(root, '[data-tvx-slider]').forEach(function (slider) {
      var track = qs(slider, '[data-tvx-track]');
      var prev = qs(slider, '[data-tvx-prev]');
      var next = qs(slider, '[data-tvx-next]');
      var dots = qs(slider, '[data-tvx-dots]');
      if (!track) return;
      var ticking = false;

      function render() {
        ticking = false;
        var width = track.clientWidth;
        if (!width) return;
        var pages = Math.max(1, Math.ceil((track.scrollWidth - 2) / width));
        slider.classList.toggle('is-static', pages <= 1);
        if (dots) {
          while (dots.children.length > pages) dots.removeChild(dots.lastChild);
          while (dots.children.length < pages) dots.appendChild(document.createElement('i'));
          var current = Math.min(pages - 1, Math.round(track.scrollLeft / width));
          Array.prototype.forEach.call(dots.children, function (dot, i) {
            dot.classList.toggle('is-active', i === current);
          });
        }
        if (prev) prev.disabled = track.scrollLeft <= 1;
        if (next) next.disabled = track.scrollLeft + width >= track.scrollWidth - 1;
      }

      function schedule() {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(render);
      }

      function move(dir) {
        var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        track.scrollBy({ left: dir * track.clientWidth, behavior: reduce ? 'auto' : 'smooth' });
      }

      if (prev) prev.addEventListener('click', function () { move(-1); });
      if (next) next.addEventListener('click', function () { move(1); });
      track.addEventListener('scroll', schedule, { passive: true });
      window.addEventListener('resize', schedule);
      render();
    });
  }

  /* ---------- Image preparation ---------- */

  function loadImageElement(file) {
    return new Promise(function (resolve, reject) {
      var url = URL.createObjectURL(file);
      var img = new Image();
      img.onload = function () {
        URL.revokeObjectURL(url);
        resolve(img);
      };
      img.onerror = function () {
        URL.revokeObjectURL(url);
        reject(new Error('decode'));
      };
      img.src = url;
    });
  }

  function loadBitmap(file) {
    if (window.createImageBitmap) {
      try {
        return window.createImageBitmap(file, { imageOrientation: 'from-image' }).catch(function () {
          return loadImageElement(file);
        });
      } catch (err) {}
    }
    return loadImageElement(file);
  }

  // Large photos are scaled down and re-encoded as JPEG before upload; small files go up untouched.
  function prepareImage(file) {
    if (file.size <= RESIZE_OVER_BYTES) return Promise.resolve(file);
    return loadBitmap(file)
      .then(function (source) {
        var scale = Math.min(1, MAX_DIMENSION / Math.max(source.width, source.height));
        var canvas = document.createElement('canvas');
        canvas.width = Math.max(1, Math.round(source.width * scale));
        canvas.height = Math.max(1, Math.round(source.height * scale));
        var ctx = canvas.getContext('2d');
        ctx.fillStyle = '#fff';
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        ctx.drawImage(source, 0, 0, canvas.width, canvas.height);
        if (source.close) source.close();
        return new Promise(function (resolve) {
          canvas.toBlob(
            function (blob) {
              resolve(blob && blob.size < file.size ? blob : file);
            },
            'image/jpeg',
            0.85
          );
        });
      })
      .catch(function () {
        return file;
      });
  }

  /* ---------- Form ---------- */

  function init(root) {
    if (root.__tvxTreqReady) return;
    root.__tvxTreqReady = true;

    initSliders(root);
    initSticky(root);

    var cfg = readConfig(root);
    var msg = cfg.messages;
    var draftKey = 'tvx-treq-draft:' + (cfg.storageKey || 'default');

    function clearDraft() {
      try {
        window.sessionStorage.removeItem(draftKey);
      } catch (err) {}
    }

    var success = qs(root, '[data-tvx-success]');
    if (success) {
      clearDraft();
      try {
        success.focus({ preventScroll: true });
      } catch (err) {}
      return;
    }

    var form = qs(root, 'form');
    if (!form) return;

    var typeInputs = qsa(form, '[data-tvx-type]');
    var otherCheck = qs(form, '[data-tvx-type-other]');
    var otherWrap = qs(form, '[data-tvx-other-wrap]');
    var otherInput = qs(form, '[data-tvx-other-input]');
    var typesOut = qs(form, '[data-tvx-types-out]');
    var bodyEl = qs(form, '[data-tvx-body]');
    var storyEl = qs(form, '[data-tvx-story]');
    var colourInputs = qsa(form, '[data-tvx-colour]');
    var noPref = qs(form, '[data-tvx-nopref]');
    var coloursOut = qs(form, '[data-tvx-colours-out]');
    var styleInputs = qsa(form, '[data-tvx-style]');
    var nameEl = qs(form, '[data-tvx-name]');
    var emailEl = qs(form, '[data-tvx-email]');
    var updatesEl = qs(form, '[data-tvx-updates]');
    var confirmInputs = qsa(form, '[data-tvx-confirm]');
    var submitBtn = qs(form, '[data-tvx-submit]');
    var submitLabel = qs(form, '[data-tvx-submit-label]');
    var fileInput = qs(form, '[data-tvx-file]');
    var drop = qs(form, '[data-tvx-drop]');
    var thumbs = qs(form, '[data-tvx-thumbs]');
    var imagesOut = qs(form, '[data-tvx-images-out]');

    var items = [];
    var counters = [];
    var submitting = false;
    var submitText = submitLabel ? submitLabel.textContent : '';
    var saveTimer = null;
    var restoring = false;

    /* Errors */

    function showError(name, text) {
      var el = qs(form, '[data-tvx-error="' + name + '"]');
      if (!el) return;
      el.textContent = text || '';
      el.hidden = !text;
    }

    function clearError(name) {
      showError(name, '');
    }

    function reveal(el) {
      var step = (el.closest && el.closest('.tvx-treq__step')) || el;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      step.scrollIntoView({ block: 'center', behavior: reduce ? 'auto' : 'smooth' });
      if (!el.disabled && el.focus) {
        try {
          el.focus({ preventScroll: true });
        } catch (err) {}
      }
    }

    /* Draft: keeps the answers if the page reloads (server-side error, captcha, accidental refresh) */

    function saveDraft() {
      if (restoring) return;
      var draft = {
        t: Date.now(),
        types: typeInputs.filter(function (i) { return i.checked; }).map(function (i) { return i.value; }),
        other: otherInput ? otherInput.value : '',
        body: bodyEl ? bodyEl.value : '',
        story: storyEl ? storyEl.value : '',
        colours: colourInputs.filter(function (i) { return i.checked; }).map(function (i) { return i.value; }),
        noPref: !!(noPref && noPref.checked),
        style: (styleInputs.filter(function (i) { return i.checked; })[0] || {}).value || '',
        name: nameEl ? nameEl.value : '',
        email: emailEl ? emailEl.value : '',
        updates: !!(updatesEl && updatesEl.checked),
        images: items
          .filter(function (item) { return item.status === 'done'; })
          .map(function (item) { return { url: item.url, name: item.name }; })
      };
      try {
        window.sessionStorage.setItem(draftKey, JSON.stringify(draft));
      } catch (err) {}
    }

    function queueSave() {
      window.clearTimeout(saveTimer);
      saveTimer = window.setTimeout(saveDraft, 300);
    }

    function restoreDraft() {
      var draft = null;
      try {
        draft = JSON.parse(window.sessionStorage.getItem(draftKey));
      } catch (err) {}
      if (!draft || !draft.t || Date.now() - draft.t > DRAFT_TTL_MS) return;

      restoring = true;
      var types = draft.types || [];
      typeInputs.forEach(function (i) { i.checked = types.indexOf(i.value) !== -1; });
      if (otherInput && draft.other) otherInput.value = draft.other;
      if (bodyEl && !bodyEl.value && draft.body) bodyEl.value = draft.body;
      if (storyEl && draft.story) storyEl.value = draft.story;
      var colours = draft.colours || [];
      colourInputs.forEach(function (i) { i.checked = colours.indexOf(i.value) !== -1; });
      if (noPref) noPref.checked = !!draft.noPref;
      styleInputs.forEach(function (i) {
        i.checked = !!draft.style && i.value === draft.style;
        i.__tvxWas = i.checked;
      });
      if (nameEl && !nameEl.value && draft.name) nameEl.value = draft.name;
      if (emailEl && !emailEl.value && draft.email) emailEl.value = draft.email;
      if (updatesEl) updatesEl.checked = !!draft.updates;
      if (thumbs) {
        (draft.images || []).slice(0, cfg.maxFiles).forEach(function (saved) {
          if (!saved || !/^https:\/\//.test(saved.url)) return;
          addItem({ name: saved.name || 'image', status: 'done', url: saved.url, preview: saved.url });
        });
      }
      restoring = false;
    }

    /* Product types */

    function syncTypes() {
      var values = [];
      typeInputs.forEach(function (input) {
        var tile = input.closest('.tvx-treq__tile');
        if (tile) tile.classList.toggle('is-checked', input.checked);
        if (!input.checked) return;
        var extra = input === otherCheck && otherInput ? otherInput.value.trim() : '';
        values.push(extra ? input.value + ': ' + extra : input.value);
      });
      if (otherWrap) otherWrap.hidden = !(otherCheck && otherCheck.checked);
      if (typesOut) typesOut.value = values.join(', ');
    }

    typeInputs.forEach(function (input) {
      input.addEventListener('change', function () {
        syncTypes();
        clearError('types');
        if (input === otherCheck && input.checked && otherInput) otherInput.focus();
        queueSave();
      });
    });
    if (otherInput) {
      otherInput.addEventListener('input', function () {
        syncTypes();
        queueSave();
      });
    }

    /* Colours: "No preference" and the swatches are mutually exclusive */

    function syncColours(changed) {
      if (changed && changed === noPref && noPref.checked) {
        colourInputs.forEach(function (i) { i.checked = false; });
      } else if (changed && changed !== noPref && changed.checked && noPref) {
        noPref.checked = false;
      }
      var values = colourInputs.filter(function (i) { return i.checked; }).map(function (i) { return i.value; });
      if (noPref && noPref.checked) values = [noPref.value];
      if (coloursOut) coloursOut.value = values.join(', ');
    }

    colourInputs.concat(noPref ? [noPref] : []).forEach(function (input) {
      input.addEventListener('change', function () {
        syncColours(input);
        queueSave();
      });
    });

    /* Pattern style: optional, so clicking the selected chip again clears it */

    styleInputs.forEach(function (input) {
      input.addEventListener('click', function () {
        var was = !!input.__tvxWas;
        styleInputs.forEach(function (i) { i.__tvxWas = false; });
        if (was) input.checked = false;
        else input.__tvxWas = true;
        queueSave();
      });
    });

    /* Character counters */

    qsa(form, '[data-tvx-count]').forEach(function (area) {
      var out = qs(area.parentNode, '[data-tvx-count-out]');
      function update() {
        if (out) out.textContent = String(area.value.length);
      }
      area.addEventListener('input', update);
      counters.push(update);
    });

    /* Text fields */

    if (bodyEl) {
      bodyEl.addEventListener('input', function () {
        bodyEl.removeAttribute('aria-invalid');
        clearError('body');
        queueSave();
      });
    }
    if (emailEl) {
      emailEl.addEventListener('input', function () {
        emailEl.removeAttribute('aria-invalid');
        clearError('email');
        queueSave();
      });
    }
    [storyEl, nameEl].forEach(function (el) {
      if (el) el.addEventListener('input', queueSave);
    });
    if (updatesEl) updatesEl.addEventListener('change', queueSave);
    function markConfirm(input, bad) {
      if (bad) input.setAttribute('aria-invalid', 'true');
      else input.removeAttribute('aria-invalid');
      var box = input.closest('.tvx-treq__ip');
      if (box) box.classList.toggle('is-invalid', bad);
    }

    confirmInputs.forEach(function (input) {
      input.addEventListener('change', function () {
        markConfirm(input, false);
        if (confirmInputs.every(function (i) { return i.checked; })) clearError('confirm');
      });
    });

    /* Uploads */

    function activeCount() {
      return items.filter(function (item) { return item.status !== 'error'; }).length;
    }

    function syncImages() {
      var done = items.filter(function (item) { return item.status === 'done'; });
      qsa(form, '[data-tvx-image-field]').forEach(function (el) {
        el.parentNode.removeChild(el);
      });
      if (imagesOut) {
        imagesOut.value = done.length ? String(done.length) : '';
        var anchor = imagesOut.nextSibling;
        done.forEach(function (item, i) {
          var input = document.createElement('input');
          input.type = 'hidden';
          input.name = 'contact[Image ' + (i + 1) + ']';
          input.value = item.url;
          input.setAttribute('data-tvx-image-field', '');
          imagesOut.parentNode.insertBefore(input, anchor);
        });
      }
      if (thumbs) thumbs.hidden = items.length === 0;
      var full = activeCount() >= cfg.maxFiles;
      if (drop) drop.classList.toggle('is-full', full);
      if (fileInput) fileInput.disabled = full;
      saveDraft();
    }

    function updateThumb(item) {
      var el = item.el;
      el.classList.toggle('is-uploading', item.status === 'uploading');
      el.classList.toggle('is-error', item.status === 'error');
      item.barEl.parentNode.hidden = item.status !== 'uploading';
      item.barEl.style.width = Math.round((item.progress || 0) * 100) + '%';
      item.msgEl.hidden = item.status !== 'error';
      item.msgEl.textContent = item.status === 'error' ? msg.uploadFailed || '' : '';
    }

    function removeItem(item) {
      var index = items.indexOf(item);
      if (index === -1) return;
      if (item.xhr && item.status === 'uploading') item.xhr.abort();
      if (item.status === 'done' && item.deleteToken) deleteByToken(item.deleteToken);
      if (item.objectUrl) URL.revokeObjectURL(item.objectUrl);
      items.splice(index, 1);
      if (item.el.parentNode) item.el.parentNode.removeChild(item.el);
      clearError('images');
      syncImages();
    }

    function addItem(item) {
      var li = document.createElement('li');
      li.className = 'tvx-treq__thumb';

      var img = document.createElement('img');
      img.alt = item.name;
      img.src = item.preview;
      li.appendChild(img);

      var bar = document.createElement('span');
      bar.className = 'tvx-treq__thumb-bar';
      var fill = document.createElement('i');
      bar.appendChild(fill);
      li.appendChild(bar);

      var note = document.createElement('span');
      note.className = 'tvx-treq__thumb-msg';
      li.appendChild(note);

      var remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'tvx-treq__thumb-x';
      remove.setAttribute('aria-label', (msg.remove || 'Remove image') + ': ' + item.name);
      remove.innerHTML = CLOSE_SVG;
      remove.addEventListener('click', function () {
        removeItem(item);
      });
      li.appendChild(remove);

      item.el = li;
      item.barEl = fill;
      item.msgEl = note;
      items.push(item);
      thumbs.appendChild(li);
      updateThumb(item);
      return item;
    }

    // Works only while Cloudinary's delete token is fresh (about 10 minutes) and if the preset returns one.
    function deleteByToken(token) {
      try {
        var data = new FormData();
        data.append('token', token);
        window
          .fetch('https://api.cloudinary.com/v1_1/' + encodeURIComponent(cfg.cloudName) + '/delete_by_token', {
            method: 'POST',
            body: data
          })
          .catch(function () {});
      } catch (err) {}
    }

    function upload(item, blob) {
      if (items.indexOf(item) === -1) return;
      var data = new FormData();
      data.append('file', blob, item.name);
      data.append('upload_preset', cfg.preset);
      data.append('tags', 'tartan-request');

      var xhr = new XMLHttpRequest();
      item.xhr = xhr;
      xhr.open('POST', 'https://api.cloudinary.com/v1_1/' + encodeURIComponent(cfg.cloudName) + '/image/upload');
      xhr.upload.onprogress = function (e) {
        if (!e.lengthComputable) return;
        item.progress = e.loaded / e.total;
        updateThumb(item);
      };
      xhr.onload = function () {
        var res = null;
        try {
          res = JSON.parse(xhr.responseText);
        } catch (err) {}
        if (xhr.status >= 200 && xhr.status < 300 && res && res.secure_url) {
          item.status = 'done';
          item.url = res.secure_url;
          item.deleteToken = res.delete_token || '';
        } else {
          item.status = 'error';
        }
        updateThumb(item);
        clearError('images');
        syncImages();
      };
      xhr.onerror = xhr.ontimeout = function () {
        item.status = 'error';
        updateThumb(item);
        syncImages();
      };
      xhr.send(data);
    }

    function addFiles(list) {
      var files = Array.prototype.slice.call(list || []);
      var room = cfg.maxFiles - activeCount();
      var problem = '';
      files.forEach(function (file) {
        if (IMAGE_TYPES.indexOf(file.type) === -1) {
          problem = msg.fileType;
          return;
        }
        if (file.size > MAX_RAW_BYTES) {
          problem = msg.fileSize;
          return;
        }
        if (room <= 0) {
          problem = (msg.maxFiles || '').replace('[max]', cfg.maxFiles);
          return;
        }
        room -= 1;
        var objectUrl = URL.createObjectURL(file);
        var item = addItem({ name: file.name, status: 'uploading', progress: 0, preview: objectUrl, objectUrl: objectUrl });
        prepareImage(file).then(function (blob) {
          upload(item, blob);
        });
      });
      showError('images', problem);
      syncImages();
      if (fileInput) fileInput.value = '';
    }

    if (fileInput && drop && thumbs) {
      fileInput.addEventListener('change', function () {
        addFiles(fileInput.files);
      });
      ['dragenter', 'dragover'].forEach(function (type) {
        drop.addEventListener(type, function (e) {
          e.preventDefault();
          drop.classList.add('is-over');
        });
      });
      ['dragleave', 'dragend'].forEach(function (type) {
        drop.addEventListener(type, function () {
          drop.classList.remove('is-over');
        });
      });
      drop.addEventListener('drop', function (e) {
        e.preventDefault();
        drop.classList.remove('is-over');
        if (e.dataTransfer) addFiles(e.dataTransfer.files);
      });
    }

    /* Validation + submit */

    function validate() {
      var firstBad = null;
      function fail(name, text, el) {
        showError(name, text);
        if (!firstBad) firstBad = el;
      }

      ['types', 'body', 'images', 'email', 'confirm', 'form'].forEach(clearError);
      syncTypes();
      syncColours();

      if (typeInputs.length && typesOut && !typesOut.value) fail('types', msg.types, typeInputs[0]);

      if (bodyEl && !bodyEl.value.trim()) {
        bodyEl.setAttribute('aria-invalid', 'true');
        fail('body', msg.body, bodyEl);
      }

      if (thumbs && drop) {
        var uploading = items.some(function (item) { return item.status === 'uploading'; });
        var doneCount = items.filter(function (item) { return item.status === 'done'; }).length;
        if (uploading) fail('images', msg.uploading, drop);
        else if (cfg.requireImage && !doneCount) fail('images', msg.imageRequired, fileInput || drop);
      }

      if (emailEl && !EMAIL_RE.test(emailEl.value.trim())) {
        emailEl.setAttribute('aria-invalid', 'true');
        fail('email', msg.email, emailEl);
      }

      var unchecked = confirmInputs.filter(function (i) { return !i.checked; });
      if (unchecked.length) {
        unchecked.forEach(function (i) { markConfirm(i, true); });
        fail('confirm', msg.confirm, unchecked[0]);
      }

      return firstBad;
    }

    function setSubmitting(on) {
      submitting = on;
      if (submitBtn) submitBtn.disabled = on;
      if (submitLabel) submitLabel.textContent = on ? msg.sending || submitText : submitText;
      // Empty optional answers are left out of the notification email.
      [typesOut, coloursOut, imagesOut, storyEl, nameEl].forEach(function (el) {
        if (!el) return;
        el.disabled = on && !el.value.trim();
      });
    }

    // Capture phase on an ancestor: runs before any submit handler bound to the form itself
    // (e.g. Shopify's captcha script), so an invalid form never reaches them.
    root.addEventListener(
      'submit',
      function (e) {
        if (e.target !== form) return;
        // Already validated: let a re-dispatched submit (e.g. after a captcha) through untouched.
        if (submitting) return;
        var bad = validate();
        if (bad) {
          e.preventDefault();
          e.stopPropagation();
          showError('form', msg.fix);
          reveal(bad);
          return;
        }
        if (emailEl) emailEl.value = emailEl.value.trim();
        window.clearTimeout(saveTimer);
        saveDraft();
        setSubmitting(true);
        window.setTimeout(function () {
          if (submitting) setSubmitting(false);
        }, 15000);
      },
      true
    );

    // Back/forward cache: returning to the page must not leave the button stuck on "Sending…".
    window.addEventListener('pageshow', function (e) {
      if (e.persisted) setSubmitting(false);
    });

    restoreDraft();
    syncTypes();
    syncColours();
    if (thumbs) syncImages();
    counters.forEach(function (update) { update(); });
  }

  function initAll() {
    qsa(document, '[data-tvx-treq]').forEach(init);
  }

  window.__tvxTreq = { initAll: initAll };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();

  // Theme editor: sections are re-rendered without a page load.
  document.addEventListener('shopify:section:load', initAll);
})();
